  (function () {
    document.querySelectorAll('[data-hero-slides]').forEach(function (root) {
      var slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      if (slides.length <= 1) return;
      var section = root.closest('.ds-hero');
      var dots = Array.from(section.querySelectorAll('[data-hero-dot]'));
      var prevBtn = section.querySelector('[data-hero-prev]');
      var nextBtn = section.querySelector('[data-hero-next]');
      var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (index < 0) index = 0;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var delay = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6000;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      }
      function next() { show(index + 1); }
      function prev() { show(index - 1); }
      function restart() {
        clearInterval(timer);
        if (autoplay && !reduceMotion) { timer = setInterval(next, delay); }
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { show(n); restart(); });
      });
      restart();
    });
  })();

  (function () {
    var root = document;
    if (!root) return;
    var els = root.querySelectorAll('[data-ds-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('ds-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ds-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  (function () {
    var root = document;
    if (!root) return;
    var accs = root.querySelectorAll('.ds-card--acc');
    if (!accs.length) return;
    var mq = window.matchMedia('(max-width: 760px)');
    // Desktop: force every card open (static look). Mobile: collapse so users tap to expand.
    function sync() { accs.forEach(function (d) { d.open = !mq.matches; }); }
    sync();
    if (mq.addEventListener) { mq.addEventListener('change', sync); }
    else if (mq.addListener) { mq.addListener(sync); }
  })();

  (function () {
    var root = document;
    if (!root) return;
    var header = root.querySelector('.ds-header');
    if (!header) return;
    function onScroll() {
      if (window.pageYOffset > 12) { header.classList.add('is-scrolled'); header.classList.remove('is-open'); }
      else { header.classList.remove('is-scrolled'); }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    // Logo / wordmark → scroll to the very top so the header expands again.
    // Only when it points at an in-page anchor: since this header went
    // site-wide the logo is a real link home on every other page, and
    // cancelling the click there left it doing nothing at all.
    root.querySelectorAll('.ds-wordmark').forEach(function (w) {
      w.addEventListener('click', function (e) {
        var href = w.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  })();

  (function () {
    var root = document;
    if (!root) return;
    var header = root.querySelector('.ds-header');
    if (!header) return;
    var panels = header.querySelectorAll('.ds-drop-panel');
    function openPanel(n) {
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ds-panel') === n); });
      header.classList.add('is-open');
    }
    function closePanel() { header.classList.remove('is-open'); }
    header.querySelectorAll('[data-ds-drop]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var n = btn.getAttribute('data-ds-drop');
        var active = header.querySelector('.ds-drop-panel.is-active');
        if (header.classList.contains('is-open') && active && active.getAttribute('data-ds-panel') === n) { closePanel(); }
        else { openPanel(n); }
      });
    });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closePanel(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
  })();

  (function () {
    var root = document;
    if (!root) return;
    var header = root.querySelector('.ds-header');
    if (!header) return;
    var burger = header.querySelector('.ds-burger');
    if (!burger) return;
    function closeMenu() { header.classList.remove('is-menu-open'); burger.setAttribute('aria-expanded', 'false'); }
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = header.classList.toggle('is-menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // tapping a menu link opens its popup — close the menu behind it
    header.querySelectorAll('.ds-header__mmenu .ds-navlink').forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  })();

  (function () {
    if (window.__cgcCart) return;
    window.__cgcCart = true;
    function setCount(n) {
      document.querySelectorAll('[data-cgc-cart-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
    }
    function bump() {
      document.querySelectorAll('.ds-cart, .cgc-cart').forEach(function (c) {
        c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
      });
    }
    function refresh(animate) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); if (animate) bump(); })
        .catch(function () {});
    }
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (url && url.indexOf('/cart/add') !== -1) {
        p.then(function (res) { if (res && res.ok) refresh(true); }).catch(function () {});
      }
      return p;
    };
  })();

  (function () {
    var root = document;
    if (!root) return;
    function closeDialog(d) { if (d.close) { d.close(); } else { d.removeAttribute('open'); } }
    root.querySelectorAll('[data-ds-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = root.querySelector('#ds-modal-' + btn.getAttribute('data-ds-modal'));
        if (!d) return;
        if (d.showModal) { d.showModal(); } else { d.setAttribute('open', ''); }
      });
    });
    root.querySelectorAll('.ds-modal').forEach(function (d) {
      d.querySelectorAll('[data-ds-close]').forEach(function (c) {
        c.addEventListener('click', function () { closeDialog(d); });
      });
      // click on the backdrop (outside the inner panel) closes
      d.addEventListener('click', function (e) { if (e.target === d) closeDialog(d); });
    });
  })();
